import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompact';

import { ANALYTICS_EVENTS } from 'src/app/analytics/analyticsEvents';
import { errorBoundary } from 'src/app/hocs';
import { extractValidationErrors } from 'src/app/popsicle/utils';
import { segmentAnalyticsEvent } from 'src/app/state/actions';
import { createLeadAction } from 'src/app/state/actions/leadForm';
import type { Dispatch, RootState } from 'src/app/state/store';

import validation from './validation';

import Renderer from '.';

const mapStateToProps = (state: RootState) => ({
  checkZipCodeEligibility: state.client.checkZipCodeEligibility,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createLead: attributes => {
    return dispatch(createLeadAction(attributes));
  },
  dispatchSubmitDoctorPageForm: attributes =>
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.DoctorPageSubmit, { attributes })),
});

const enhanceWithFormik = withFormik({
  mapPropsToValues: validation.initialValues,
  validationSchema: validation.schema,
  validateOnChange: true,
  validateOnBlur: false,
  handleSubmit: async (values, { props, setErrors, setSubmitting, setStatus }) => {
    const { createLead, source, dispatchSubmitDoctorPageForm, checkZipCodeEligibility } = props;
    const { doctorName, email, zipCode, specialty } = values;
    const attributes = { source, doctorName, email, zipCode, specialty };
    setSubmitting(true);

    try {
      await createLead(attributes);
      const zipResult = await checkZipCodeEligibility(zipCode);
      const isDeliverable = zipResult.data?.isDeliverable;

      dispatchSubmitDoctorPageForm(attributes);
      setStatus({
        success: true,
        isDeliverable,
      });
      setSubmitting(false);
    } catch (error) {
      setErrors(extractValidationErrors(error));
      setSubmitting(false);
    }
  },
});

export default compose(
  errorBoundary,
  setDisplayName('DoctorLeadForm'),
  connect(mapStateToProps, mapDispatchToProps),
  enhanceWithFormik
)(Renderer);
